import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, onMounted, ref } from "vue";
import type { SizeType } from "ant-design-vue/es/config-provider";
import {
  filterAreaOption,
  loadAreaTree,
  mapAreaOptions,
  findAreaById,
  type AreaNode,
  type AreaSelectOption,
} from "./useArea";

interface Props {
  modelValue?: string | number | null;
  placeholder?: string;
  disabled?: boolean;
  size?: SizeType;
  allowClear?: boolean;
  showSearch?: boolean;
  loading?: boolean;
  status?: "" | "error" | "warning";
  notFoundContent?: string;
  /** Nếu truyền sẵn tree thì không gọi API */
  areas?: AreaNode[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ProvinceSelect',
  props: {
    modelValue: { default: null },
    placeholder: { default: "Chọn Tỉnh / Thành phố" },
    disabled: { type: Boolean, default: false },
    size: { default: "middle" },
    allowClear: { type: Boolean, default: true },
    showSearch: { type: Boolean, default: true },
    loading: { type: Boolean, default: false },
    status: { default: "" },
    notFoundContent: { default: "Không có dữ liệu" },
    areas: { default: undefined }
  },
  emits: ["update:modelValue", "change"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const internalLoading = ref(false);
const provinceList = ref<AreaNode[]>([]);

const options = computed(() => mapAreaOptions(props.areas ?? provinceList.value));

const innerValue = computed({
  get: () => props.modelValue,
  set: (val: string | number | null) => emit("update:modelValue", val),
});

onMounted(async () => {
  if (props.areas?.length) {
    provinceList.value = props.areas;
    return;
  }
  internalLoading.value = true;
  provinceList.value = await loadAreaTree();
  internalLoading.value = false;
});

const onChange = (val: string | number | null, option: any) => {
  const selected = (option as AreaSelectOption) || null;
  const node = selected?.raw || findAreaById(props.areas ?? provinceList.value, val);
  emit("update:modelValue", val);
  emit("change", val, selected, node?.children || []);
};

return (_ctx: any,_cache: any) => {
  const _component_a_select = _resolveComponent("a-select")!

  return (_openBlock(), _createBlock(_component_a_select, {
    value: innerValue.value,
    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((innerValue).value = $event)),
    options: options.value,
    placeholder: _ctx.placeholder,
    disabled: _ctx.disabled,
    size: _ctx.size,
    "allow-clear": _ctx.allowClear,
    "show-search": _ctx.showSearch,
    "filter-option": _unref(filterAreaOption),
    loading: _ctx.loading || internalLoading.value,
    status: _ctx.status,
    "not-found-content": _ctx.notFoundContent,
    class: "ant-province-select",
    onChange: onChange
  }, null, 8, ["value", "options", "placeholder", "disabled", "size", "allow-clear", "show-search", "filter-option", "loading", "status", "not-found-content"]))
}
}

})